import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";
import { downloadBlob } from "@/utils/blob";
import { AuthService, DossierConfigService } from ".";
import { MODULE } from "@/config/modules";
export interface IParticipantInfoResponse {
	Registered:boolean;
	IsInvoiceCompatible:boolean;
	IsCreditNoteCompatible:boolean;
	IsSelfBilledInvoiceCompatible:boolean;
	IsSelfBilledCreditNoteCompatible:boolean;
	DocumentTypes:string[];
}

export interface IPeppolRegistration {
	DossierID: number;
	PeppolID: string;
	SendOnly:boolean;
}

class PeppolServiceClass {
	private readonly URL = `${ServerConfig.host}/peppol`;

	public async processIncommingPeppolMessages(){
		await Axios.post(`${this.URL}/fetch-and-store-peppol-docs`);
	}

	async getParticipantInfo(vat:string):Promise<IParticipantInfoResponse> {
		let response = await Axios.get(`${this.URL}/participant-info/${encodeURIComponent(vat)}`);
		return response.data;
	}

	async getRegistrationData():Promise<IPeppolRegistration[]> {
		let response = await Axios.get(`${this.URL}/registrations`);
		return response.data;
	}

	async sendSale(saleID:number, po:string, deliveryNumber:string, files:File[], endpointID:string = "") {
		let body = new FormData();
		body.append("PO", po);
		body.append("DeliveryNumber", deliveryNumber);
		if (endpointID) {
			body.append("EndpointID", endpointID);
		}
		body.append("FileCount", `${files.length}`);
		for (let i = 0; i < files.length;i++) {
			body.append(`file-${i}`, files[i], files[i].name);
		}

		await Axios.post(`${this.URL}/send-sale/${saleID}`, body);
	}

	async downloadUbl(saleId:number, po:string, deliveryNumber:string, files:File[]) {
		let body = new FormData();
		body.append("PO", po);
		body.append("DeliveryNumber", deliveryNumber);
		body.append("FileCount", `${files.length}`);
		for (let i = 0; i < files.length;i++) {
			body.append(`file-${i}`, files[i], files[i].name);
		}

		let result = await Axios.post(`${this.URL}/download-ubl/${saleId}`, body);
		let blob = new Blob([result.data], {type: "application/xml"});
		downloadBlob(blob, "peppol-ubl.xml");
	}

	async isPeppolReadyForSending():Promise<boolean>{
		if (!AuthService.hasModule(MODULE.ELECTRONISCHE_FACTURATIE)) return false;
		if (!AuthService.wfDossier.isFilledIn) return false;
		if (!DossierConfigService.getPluginConfig().UBL.isPeppolConfigured()) return false;
		let metadata = AuthService.wfCompany.Modules.find(m=>m.ID == MODULE.ELECTRONISCHE_FACTURATIE)?.MetaData;
		if (!metadata) return false;
		if (metadata["uses-winfakt-peppol"]){
			let registrations = await this.getRegistrationData();
			if (registrations.length == 0) return false;
		}
		return true;
	}
}


export const PeppolService = new PeppolServiceClass();